export default {
  Recovery: 1, // Phục hồi dữ liệu
  BackUp: 2, // Sao lưu dữ liệu,
};
